export class LoadedStores {
	Id: number;
	DispensingEventTbl!: boolean;
	EditUserTbl!: boolean;
	EditEmergencyEventTbl!: boolean;
	UnitTbl!: boolean;
	BarcodeTbl!: boolean;
	SiteLocationDetailTbl!: boolean;
	ClientDetailTbl!: boolean;
	AssetDetailTbl!: boolean;

	constructor() {
		this.Id = 1;
		this.DispensingEventTbl = false;
		this.EditUserTbl = false;
		this.EditEmergencyEventTbl = false;
		this.UnitTbl = false;
		this.BarcodeTbl = false;
		this.SiteLocationDetailTbl = false;
		this.ClientDetailTbl = false;
		this.AssetDetailTbl = false;
	}
};
